// Package Imports
// import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Loading from 'components/loading/loading';
import PrivateRouteConst from 'core/common/privateRouteConstant';

// Project Imports
// const DashboardChartMapping = lazy(
//   () => import('pages/dashboardMapping/dashboardChartMapping')
// );
const UploadUtr = lazy(() => import('pages/uploadUtr/uploadUtr'));
const UploadUtrRoute = (
  <Route path={routeName.uploadUtr}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.UPLOAD_UTR_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <UploadUtr />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default UploadUtrRoute;
